import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';

export const getStringInitials = (value: string) => {
  return value[0];
};

export const pascalizeString = (str: string) => {
  return upperFirst(camelCase(str));
};